import { useEffect, useState } from 'react'

export const useReturnUrl = () => {
  const [returnUrl, setReturnUrl] = useState('')

  useEffect(() => {
    setReturnUrl(
      encodeURIComponent(
        `${window.location.pathname}${window?.location.search || ''}`,
      ),
    )
  }, [])
  return returnUrl
}
